import {Component} from "@angular/core";
import {Router} from "@angular/router";
import {HttpClient, HttpContext} from "@angular/common/http";
import {BYPASS_CACHE} from "../../core/interceptors/caching.interceptor";
import {BYPASS_ERROR} from "../../core/interceptors/server-error.interceptor";
import {catchError} from "rxjs/operators";
import {firstValueFrom, of} from "rxjs";
import {PageNotFoundService} from "../../core/services/services/page-not-found.service";

interface SearchResponse {
	status: number;
	type?: string;
	location?: string;
	data?: string[];
}

@Component({
	selector: "app-search-wrapper",
	templateUrl: "./search-wrapper.component.html",
	styleUrls: ["./search-wrapper.component.scss"],
	standalone: true,
})
export class SearchWrapperComponent {
	constructor(
		private _router: Router,
		private _http: HttpClient,
		private _pageNotFoundService: PageNotFoundService,
	) {
		this.init().then();
	}

	async init() {
		if (this._router.url.endsWith("search/")) {
			await this._pageNotFoundService.navigateTo();
			return;
		}

		let response = await firstValueFrom(
			this._http
				.get<SearchResponse>("/mep/api/search/" + this._router.url.split("/search/")[1], {
					context: new HttpContext().set(BYPASS_CACHE, true).set(BYPASS_ERROR, true),
				})
				.pipe(
					catchError(() => {
						return of({
							status: 404,
						} as SearchResponse);
					}),
				),
		);

		if (response.status === 302) {
			await this._router.navigateByUrl(response.location);
			return;
		}
		await this._pageNotFoundService.navigateTo({
			status: response.status,
			type: response.type,
			data: response.data,
		});
	}
}
